function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 1c5.523 0 10 4.477 10 10s-4.477 10-10 10S1 16.523 1 11 5.477 1 11 1",
  fill: "#0079BF"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1c5.523 0 10 4.477 10 10s-4.477 10-10 10S1 16.523 1 11 5.477 1 11 1",
  stroke: "#fff"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.638 13.938c-.096 0-.16.03-.208.166-.692 1.654-1.174 1.7-1.35 1.7-.21 0-.402-.229-.193-.804l1.655-4.717c.176-.487.193-1.001-.257-1.26-.226-.137-.547-.167-.739-.167-.643 0-1.768.426-2.65.91-.13.077-.145.153-.082.26l.129.226c.048.076.112.091.241.031.226-.091.579-.212.819-.273.338-.091.628 0 .482.409L9.12 14.422c-.113.319-.194.699-.194.956 0 .818.58 1.426 1.511 1.426 1.06 0 1.896-.668 2.635-2.669.049-.137 0-.183-.111-.183l-.323-.014zM13.634 6.567c.049-.622-.449-1.123-1.14-1.123-.691 0-1.269.501-1.318 1.123-.032.622.45 1.123 1.14 1.123.692 0 1.287-.501 1.318-1.123z",
  fill: "#fff"
});
function SvgInfoToast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default SvgInfoToast;